import { Components, CssVarsTheme, Theme } from "@mui/material";

const TextField = (
  theme: Theme
): Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> => ({
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: theme.palette.text.required,
        "&$error": {
          color: theme.palette.text.required,
        },
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        ".MuiInputBase-root": {
          gap: "4px",
        },
        borderRadius: "8px",
        WebkitFontSmoothing: "antialiased",
        "& label": {
          color: "#4B5675",
          WebkitFontSmoothing: "antialiased",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderRadius: "8px",
            borderColor: "#DBDFE9",
          },
        },
      },
    },
  },
});

export default TextField;
